<template>
  <div class="file-item">
    <div style="line-height: 1.8;flex: 1;" @click="hasfile">{{ fileName }}</div>
    <div v-if="!downratio" @click="hasfile" style="width: 100px; text-align: right;">查看</div>
    <div v-if="downratio" style="width: 100px; text-align: right;">已下载:{{ downratio }}</div>
  </div>
</template>

<script>
  import { DownLoadFileURL } from '@http/config';
  export default {
    name: 'h5Download',
    components: {},
    props: {
      fileInfo: {
        type: Object,
        default: {}
      },
      callback: {
        type: [Function, Object],
        default: null
      },
    },
    data() {
      return {
        status: false,
        dtask: null,
        ratio: 0
      }
    },
    created() {},
    watch: {},
    computed: {
      downUrl() {
        let { fileId } = this.fileInfo;
        return DownLoadFileURL + '/api/ycloud-file-center/oper/download?access_token=' + this.token + '&fileId=' + fileId
      },
      fileName() {
        return this.fileInfo ? this.fileInfo.fileName + this.fileInfo.suffixName : '';
      },
      downratio() {
        return (this.ratio !== 0 && this.ratio < 100) ? (this.ratio + '%') : ''
      },
      options() {
        let param = {
          method: 'GET',
          filename: '_downloads/' + this.fileName
        }
        return param
      }
    },
    methods: {
      hasfile() {
        plus.io.resolveLocalFileSystemURL(this.options.filename, (entry) => {
          if (entry.isFile) {
            plus.runtime.openFile(entry.toLocalURL(entry.fullPath));
          }
        }, (e) => {
          this.createDownload();
        });
      },
      createDownload() {
        if (!window.plus) {
          this.$toast('未加载 plus模块')
          return
        }
        if (this.status) return
        this.status = true;
        var dtask = plus.downloader.createDownload(this.downUrl, this.options, (d, status) => {
          // 下载完成
          this.status = false;
          if (status == 200) {
            console.log("Download success: " + JSON.stringify(d));
          } else {
            this.$toast('下载失败！' + status);
          }
        });
        dtask.addEventListener("statechanged", this.onStateChanged, false);
        dtask.start();
      },
      onStateChanged(download, status) {
        if (download.totalSize != '' && download.downloadedSize != '') {
          this.ratio = ((download.downloadedSize / download.totalSize) * 100).toFixed(2);
        }
        if (download.state == 4 && status == 200) {
          plus.runtime.openFile(download.getFileName());
        }
      }
    },
    mounted() {}
  }
</script>

<style lang="scss" scoped>
  .file-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    word-break: break-all;
    color: #1989fa;
    font-size: 14px;
  }
</style>
